import { genreOptionsAssessment } from "../../constants";
import classes from "./CreateQuestions.module.css";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectFormData,
  setFormData,
} from "../../slices/form";
import SpecialInstructions from "../CriteriaSubmission/assesmentForm/specialInstructions";

import TypeOfTest from "../CriteriaSubmission/assesmentForm/typeOfTest";
import QuestionsTypes from "../CriteriaSubmission/assesmentForm/questionTypes";

const closedBookOptions = {
  knowledge: true,
  analysis: true,
  comprehension: true,
  application: true,
};

const openBookOptions = {
  theme: true,
  analysis: true,
  structure: true,
  tone: true,
  vocabulary: true,
};

const mathOptions = {
  fluency: true,
  concept: true,
  application: true,
  reasoning: true,
};

function CreateQuestionsForm({ isLoading }) {
  const formData = useSelector(selectFormData) || {};
  const dispatch = useDispatch();

  const { questions = {}, subject } = formData;

  const handleInputChange = (event) => {
    if (subject === "Math") {
      return; // Skip if subject is Math
    }
    const { name } = event.target;
    let inputValue = event.target.value;

    let updates = { [name]: inputValue };

    if (name === "show_text") {
      const selectedOptions = {
        "Closed book": closedBookOptions,
        "Open book": openBookOptions,
        "None selected": {},
        "Math": mathOptions
      }
      updates = {
        ...updates,
        genre: genreOptionsAssessment[0],
        questions: {
          ...questions,
          skills: selectedOptions[inputValue]
        },
      };
    }

    dispatch(setFormData(updates));
  };

  useEffect(() => {
    let initialSkills = {};
    if (subject === "Math") {
      initialSkills = mathOptions;
    } else if (formData?.show_text === "Open book") {
      initialSkills = openBookOptions;
    } else if (formData?.show_text === "Closed book") {
      initialSkills = closedBookOptions;
    }

    dispatch(
      setFormData({
        questions: {
          ...questions,
          skills: initialSkills,
          question_scope_passage_only: true, // Default to true for generated text's questions
        },
      })
    );
  }, [dispatch, subject, formData?.show_text]); // Ensure effect runs if subject or show_text changes

  return (
    <>
     

      <div className={classes["input-container"]} style={{ width: "100%" }}>
     
          <TypeOfTest
            isLoading={isLoading}
            handleInputChange={handleInputChange}
          />
          <QuestionsTypes />
      </div>

      
     
      
      <SpecialInstructions isLoading={isLoading} />
    </>
  );
}

export default CreateQuestionsForm;
